import esquire from "./esquire";
window.$ = window.jQuery = window.jquery = require('jquery');
esquire.define('jquery', $);